/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Leaderboard_DescriptionInputs */

const en_directory_vibebids_leaderboard_description = /** @type {(inputs: Directory_Vibebids_Leaderboard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The highest bid wins each rank. Tie-breaks go to the earliest bid.`)
};

const zh_directory_vibebids_leaderboard_description = /** @type {(inputs: Directory_Vibebids_Leaderboard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个排名由最高出价获得。同价时，较早提交的出价优先。`)
};

/**
* | output |
* | --- |
* | "The highest bid wins each rank. Tie-breaks go to the earliest bid." |
*
* @param {Directory_Vibebids_Leaderboard_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_leaderboard_description = /** @type {((inputs?: Directory_Vibebids_Leaderboard_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Leaderboard_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_leaderboard_description(inputs)
	return zh_directory_vibebids_leaderboard_description(inputs)
});
export { directory_vibebids_leaderboard_description as "directory.vibebids.leaderboard_description" }